<!--
 * @Description: 交叉分析表与卡方分析
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="240" :itemWidth="420 + 56">
      <div
        style="height: 230px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 230px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
            style="height: 200px !important"
          >
            <div
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
                white-space: wrap;
              "
            >
              <div style="color: #222; font-size: 21px">
                <div>{{ analysis[0].analysisMethodDescription }}</div>
                <div style="font-size: 22px; font-weight: bold; margin: 12px 0">
                  1.{{ analysis[0].title }}
                </div>
                <div>{{ analysis[0].desc }}</div>
                <div style="font-size: 22px; font-weight: bold; margin: 12px 0">
                  {{ analysis[0].crossTitle }}
                </div>
                <div style="margin-bottom: 24px">
                  {{ analysis[0].crossDesc }}
                </div>
              </div>
              <component
                :is="cmpName(item.value)"
                v-bind="{
                  tableHeaderList: analysis[0].table.header,
                  tableDataList: analysis[0].table.value
                }"
              />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModuleCrossAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-cross-analysis';

import { BaseRadio } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import { analysis } from '../../../../mock/_analysis';
import { BaseCard } from 'xrk-components';

const CHILD_KEY = '6_1';
const TYPE_MAPPING = {
  1: {
    value: 'pc-module-cross-analysis-1',
    moduleType: 'pc-module-cross-analysis-1'
  },
  2: {
    value: 'pc-module-cross-analysis-2',
    moduleType: 'pc-module-cross-analysis-2'
  },
  3: {
    value: 'pc-module-cross-analysis-3',
    moduleType: 'pc-module-cross-analysis-3'
  },
  4: {
    value: 'pc-module-cross-analysis-4',
    moduleType: 'pc-module-cross-analysis-4'
  },
  5: {
    value: 'pc-module-cross-analysis-5',
    moduleType: 'pc-module-cross-analysis-5'
  },
  6: {
    value: 'pc-module-cross-analysis-6',
    moduleType: 'pc-module-cross-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleCrossAnalysis.filter(comp => comp.__name === name)[0];
};
</script>
<style scoped lang="scss"></style>
